import * as angular from "angular";
import {IWindowService} from "angular";
import {SplitService} from "./split-service.service";

export class QuickFilterContextService {

  constructor(private $window: IWindowService, private $state, private splitService: SplitService) {
  }

  getQuickFilterId(siteId?: string, pageName?: string) {
    siteId = siteId || this.splitService.getSiteId();
    pageName = pageName || this.$state.current.name;
    let quickFilterIdContext = angular.fromJson(this.$window.localStorage.getItem('quickFilterContextService'));

    if (!quickFilterIdContext) {
      quickFilterIdContext = {};
    }

    return quickFilterIdContext[siteId] ? quickFilterIdContext[siteId][pageName] : undefined;
  }

  setQuickFilterId(quickFilterId?: string, siteId?: string, pageName?: string) {
    let quickFilterContextService = angular.fromJson(this.$window.localStorage.getItem('quickFilterContextService'));
    siteId = siteId || this.splitService.getSiteId();
    pageName = pageName || this.$state.current.name;

    if (!quickFilterContextService) {
      quickFilterContextService = {};
    }
    if (!quickFilterContextService[siteId]) {
      quickFilterContextService[siteId] = {};
    }

    quickFilterContextService[siteId][pageName] = quickFilterId;
    this.$window.localStorage.setItem('quickFilterContextService', angular.toJson(quickFilterContextService));
  }

  getActiveQuickFilter(pageName: string) {
    const siteId = this.splitService.getSiteId();
    let quickFilterIdContext = angular.fromJson(this.$window.localStorage.getItem('activeQuickFilter'));

    if (!quickFilterIdContext) {
      quickFilterIdContext = {};
    }

    return quickFilterIdContext[siteId] ? quickFilterIdContext[siteId][pageName] : undefined;
  }


}


angular
  .module('bringoz.admin.commons')
  .service('quickFilterContextService', QuickFilterContextService);
